import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { spacingHelper, mediaHelper } from '@property.com.au/ui-kit';
import { mapDynamicContentItems } from '../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';
import { SupplyDemandAndPerformanceBrick } from './subcomponents/SupplyDemandAndPerformanceBrick/SupplyDemandAndPerformanceBrick';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { ObservedElement } from '../../../app-kit/components/ObservedElement/ObservedElement';
import { MedianCostBrick } from './subcomponents/MedianCostBrick/MedianCostBrick';
import { StyledProptrackLogoBrickSource } from '../../../components/ProptrackLogoBrickSource/ProptrackLogoBrickSource';

const StyledMedianCostBrick = styled(MedianCostBrick)`
  margin: unset;

  ${mediaHelper('desktopMin')} {
    flex-grow: 1;
    width: 0;
  }
`;

const MarketInsightsWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: ${spacingHelper('extraSmall')};
`;

const StyledSupplyDemandAndPerformanceBrick = styled(SupplyDemandAndPerformanceBrick)`
  margin-top: ${spacingHelper('extraSmall')};
`;

export const MarketInsightsBrickWithData: FunctionComponent = () => {
  const marketInsights = usePropertyPageQuery()?.data?.propertyPageBySlugV3?.marketInsightsV3;
  const [renderLazyCharts, setRenderLazyCharts] = useState(false);

  if (!marketInsights) return null;

  const { title, subtitle, medianPrice, medianRent, supplyDemandAndPerformance } = marketInsights;

  if (!medianPrice && !medianRent && !supplyDemandAndPerformance) return null;

  return (
    <ContentBrick title={title} subtitle={subtitle}>
      <ObservedElement onIntersect={() => setRenderLazyCharts(true)}>
        <MarketInsightsWrapper>
          {medianPrice && (
            <StyledMedianCostBrick
              title={medianPrice.title}
              subtitle={medianPrice.subtitle}
              disclaimer={medianPrice.disclaimer}
              cost={medianPrice.cost}
              costChange={medianPrice.costChange}
              graph={medianPrice.graph}
              renderGraph={renderLazyCharts}
              graphId="colorCostGreen"
            />
          )}
          {medianRent && (
            <StyledMedianCostBrick
              title={medianRent.title}
              subtitle={medianRent.subtitle}
              disclaimer={medianRent.disclaimer}
              cost={medianRent.cost}
              costChange={medianRent.costChange}
              graph={medianRent.graph}
              renderGraph={renderLazyCharts}
              graphId="colorCostBlue"
            />
          )}
        </MarketInsightsWrapper>
        {supplyDemandAndPerformance && subtitle && (
          <StyledSupplyDemandAndPerformanceBrick
            title={supplyDemandAndPerformance.title}
            subtitle={mapDynamicContentItems(supplyDemandAndPerformance.subtitle)}
            graph={supplyDemandAndPerformance.graph}
            renderGraph={renderLazyCharts}
          />
        )}
        <StyledProptrackLogoBrickSource />
      </ObservedElement>
    </ContentBrick>
  );
};
